import React from 'react'
import PropTypes from 'prop-types'
import ReactTooltip from 'react-tooltip'
import { Flex } from '@chatterbug/aaron'
import LanguageFlags from 'src/ui/LanguageFlags/LanguageFlags'
import { t } from 'src/lib/i18n-react'

const TutorLanguages = ({ fluentLanguages }) => {
  const toolTipText = t(`Languages spoken %{langs}`, {
    langs: fluentLanguages.map((l) => l.localizedName).join(', '),
  })

  const languageCodes = fluentLanguages.map((l) => l.code)

  const toolTip = () => {
    return `<div style="max-width: 220px">${toolTipText}</div>`
  }
  return (
    <Flex flexShrink={0} data-tip="" data-html sx={{ position: 'relative' }}>
      <LanguageFlags languages={languageCodes} />
      <ReactTooltip
        effect="solid"
        place={'bottom'}
        delayShow={10}
        backgroundColor="black0"
        className="react-tooltip"
        maxWidth="100px"
        getContent={() => toolTip()}
      />
    </Flex>
  )
}

TutorLanguages.propTypes = {
  fluentLanguages: PropTypes.array,
}

export default TutorLanguages
